import Cookies from 'js-cookie'
import { axiosClassic, axiosWithAuth } from '../api/interceprots'
import { setAuthCookies } from '../api/tokens'
export const AuthService = {
	async login(username: string, password: string) {
		const response = await axiosClassic.post('auth/authorize/password', {
			username,
			password,
		})
		setAuthCookies(response.data)
		return response
	},
	async register(
		email: string,
		username: string,
		first_name: string,
		password: string,
		invite_code?: string
	) {
		const response = await axiosClassic.post('auth/register', {
			email,
			username,
			first_name,
			password,
			invite_code,
		})
		return response
	},
	async getUserInfo() {
		const id = Cookies.get('userId')
		const response = await axiosWithAuth.get(`users/${id}`)
		return response
	},
	async getNewTokens() {
		const refreshToken = Cookies.get('refreshToken')
		const response = await axiosClassic.post('auth/refresh', {
			refresh_token: refreshToken,
		})
		setAuthCookies(response.data)
		return response
	},
	async startReset(email: string) {
		const response = await axiosClassic.post('auth/reset-password', { email })
		return response
	},

	async confirmReset(email: string, code: string) {
		const body = { email, code }
		const response = await axiosClassic.post('auth/confirm-reset', body)

		setAuthCookies(response.data)

		return response
	},
}
